import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";

// context
import { useAuth } from "./AuthContext";

// idle-timer
import { useIdleTimer } from "react-idle-timer";

// token 
import { ensureAuth, clearAccessToken } from "./token";

// axios
import { api } from "@/api/axios";


const blockedListUrl = ['/medCard', '/makeAppointment/direction'];

export default function RequireVerified({ children }) {
  const { 
    isVerified, 
    setIsShowWarning, 
    setMessageWarning, 
    setIsVerified, 
    setIsFillProfile, 
    isVerificationLoading,
    setIsVerificationLoading
  } = useAuth();
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate()

  const [authState, setAuthState] = useState({
    loading: true,
    success: false
  });

  // проверка на валидность токена
  useEffect(() => {
    let active = true;

    (async () => {
      const result = await ensureAuth();

      if (!active) return;

      setAuthState({
        loading: false,
        success: result.success
      });
    })();

    return () => {
      active = false;
    };
  }, [pathname]);

  useEffect(() => {
    if (isVerified) return;

    const getDataUser = async () => {
      setIsVerificationLoading(true);  
      try {
        const res = await api.post('/gates/data/get_user_data', {});

        const data = res.data;
        const dataProfileIsVerified = data.USER_CONFIRMED;
        const dataProfileIsFill = data.PROFILE_SAVE;
        const typeError = data?.ERROR?.CODE;

        localStorage.setItem('email', data.EMAIL);

        if(!dataProfileIsVerified) {
          setIsVerified(false);
        } else {
          setIsVerified(true);
        }

        if (!dataProfileIsFill) {
          setIsFillProfile(false);
        } else {
          setIsFillProfile(true);
        }

        if (data?.SUCCESS === false && typeError === 'INVALID_TOKEN') {
          navigate('/login');
        }
      } catch (error) {
        const statusCode = error?.response?.status;

        if (statusCode === 404 || statusCode === 502) {
          setIsShowWarning(true);
          setMessageWarning({
            title: 'Ошибка соединения!',
            description: badRequestMessage
          });
        }

        console.error(error);
      } finally {
        setIsVerificationLoading(false); 
      }
    }
    getDataUser();
  }, [pathname])


  useEffect(() => {
    setIsShowWarning(false);
    setMessageWarning({
      title: '',
      description: ''
    })
  }, [pathname])

  // Функция которая отрабатывает, если пользователь бездействует
  const handleOnIdle = () => {
    clearAccessToken();
    return navigate('/login');
  }

  useIdleTimer({
    timeout: 15 * 60 * 1000,
    onIdle: handleOnIdle,
    debounce: 1000,  // вызываем раз в 1 секунду
    events: ['mousemove', 'keydown', 'wheel', 'touchstart', 'click']
  })

  if (authState.loading) {
    return null;
  }

  if(isVerificationLoading) {
    return null;
  }

  if (!authState.success) {

    localStorage.removeItem('isFillProfile');
    localStorage.removeItem('isVerified');
    
    return <Navigate to='/login' state={{ from: location }} replace />
  }

  if (!isVerified) {
    const isBlocked = blockedListUrl.some((path) => pathname === path || pathname.startsWith(path));

    if (isBlocked) {
      return <Navigate to='/main?mode=confirm' replace/>
    }
  }
  return children;
}